import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/auth.css';

export default function NotFound() {
  return (
    <div className="wp-auth">
      <header className="wp-auth__header">
        <Link to="/" className="wp-auth__wordmark">WOSS PUBLISHING</Link>
      </header>
      <main className="wp-auth__main">
        <div className="wp-auth__card" style={{ textAlign: 'center' }}>
          <p className="wp-auth__eyebrow" style={{ justifyContent: 'center' }}>
            404
          </p>
          <h1 className="wp-auth__heading">Page not found</h1>
          <p className="wp-auth__sub">
            The page you are looking for does not exist or has been moved.
          </p>
          <div className="wp-auth__links">
            <Link to="/" className="wp-auth__link">← Return to homepage</Link>
          </div>
        </div>
      </main>
      <footer className="wp-auth__footer">
        &copy; {new Date().getFullYear()} Woss Publishing. All rights reserved.
      </footer>
    </div>
  );
}
